import { ModelInstance, BaseModel, ToFrontHook, ToBackHook } from './util';

@ModelInstance({
  mappingFields: {
    id: 'id',
    name: 'name',
    address: 'address',
    league_id: 'leagueId',
    active_games_count: 'activeGamesCount',
  }
})
export class LeagueCourt extends BaseModel {
  id: number;
  name: string;
  address: string;
  leagueId: number;
  activeGamesCount: number;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
